module.exports = __webpack_public_path__ + "6086bb89d4200547ed26e7a4881998ec.jpg";